import { getIn } from "final-form";
import {
  ApplicationContextType,
  MonthlyReportSteps,
  StatementAnalysisStatus,
  UnderwritingSteps,
  uploadStates,
} from "../../../interfaces/interfaces";

export const bankStatementValidator = (
  values,
  underwritingFileJobs,
  statementJobs,
  formType
) => {
  let allErrorsObj = {};
  const bankStatements = values?.bankStatements;
  const rootError = [];
  const statementError = [];
  const passwordError = [];
  const failureStates = new Set([
    StatementAnalysisStatus.failure,
    StatementAnalysisStatus.requestTimedOut,
  ]);

  if (!bankStatements || !bankStatements.length) {
    allErrorsObj["rootBankError"] = "Please add atleast one bank account";
    rootError.push("Please add atleast one bank account");
  } else {
    const allBankStatementJobs = getIn(
      underwritingFileJobs,
      formType == ApplicationContextType.monthlyReport
        ? `${MonthlyReportSteps.bankStatement}`
        : UnderwritingSteps.documents
    );
    const errors = [];
    bankStatements.forEach((bankAccount, index) => {
      const statements = bankAccount?.statements;
      const statementType = bankAccount?.statementType;
      let accountErrorsObj = {};
      if (!statements || !statements.length) {
        //   errors[`bankStatements[${index}].statements`] = "Please upload bank statement";
        accountErrorsObj["accountError"] = "Please upload bank statement";
        rootError.push("Please upload bank statement");
      } else {
        if (formType == ApplicationContextType.monthlyReport) {
          const isAnyFileUploaded = checkIfAnyFileUploaded(statements);
          if (!isAnyFileUploaded) {
            accountErrorsObj["accountError"] = "Please upload bank statement";
            rootError.push("Upload your bank statements");
          }
        }
        const statementJob = bankAccount?.statementJobId;
        const currentJob = getIn(
          statementJobs,
          `${statementJob}.${statementType}`
        );
        if (currentJob && failureStates.has(currentJob.status)) {
          accountErrorsObj[`processingError`] = "Statement processing failed";
          statementError.push("Statement processing failed");
        }
        const fileErrorArr = [];
        statements.forEach((uploadedFile, fileIndex) => {
          let errorObj = "";
          const fileKey = `bankStatements[${index}].statements[${fileIndex}]`;
          //   console.log("fileKey", fileKey);

          const uploadedFileJob = allBankStatementJobs
            ? allBankStatementJobs[fileKey]
            : null;
          if (uploadedFileJob?.status == uploadStates?.requiredPassword) {
            errorObj = "Please enter password";
            passwordError.push("Please enter password");
          } else {
            errorObj = "";
          }
          fileErrorArr.push(errorObj);
        });
        accountErrorsObj[`statements`] = fileErrorArr;
        // const filteredErrorArr = fileErrorArr.filter((error) => {
        //   if (error) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // });
        // if (filteredErrorArr?.length) {
        //   accountErrorsObj[`fileError`] = filteredErrorArr;
        //   passwordError.push("Please enter password");
        // }
      }
      errors.push(accountErrorsObj);
    });
    allErrorsObj = errors;
  }

  return {
    errors: allErrorsObj,
    allErrors: {
      rootError: rootError,
      statementError: statementError,
      passwordError: passwordError,
    },
  };
};

const checkIfAnyFileUploaded = (statements) => {
  if (!statements || !statements.length) {
    return false;
  }
  const isAnyFileUploaded = statements.some((statement) => {
    return !statement?.uploadedFile?.isOldFile;
  });
  return isAnyFileUploaded;
};

export const sanitizeArrayErrors = (errors) => {
  //   console.log("sanitizeArrayErrors", errors);
  //   console.log("array is array", !Array.isArray(errors));
  if (!Array.isArray(errors)) return undefined;

  const cleaned = errors.map((item) => {
    // skip non-objects or completely empty
    if (!item || typeof item !== "object") return undefined;
    // console.log("item", item);s
    const result = {};
    for (const [key, val] of Object.entries(item)) {
      if (Array.isArray(val)) {
        // keep only non-empty strings
        const filtered = val.filter(
          (v) => typeof v === "string" && v.trim().length
        );
        if (filtered.length) result[key] = filtered;
      } else if (val != null && val !== "") {
        // keep any other truthy / non-empty value
        result[key] = val;
      }
    }

    // if nothing left, drop this index
    // console.log("result", result);
    return Object.keys(result).length ? result : undefined;
  });

  //   console.log("cleaned errors", cleaned);

  // if any real error remains, return the array; otherwise undefined
  return cleaned.some((entry) => entry !== undefined) ? cleaned : undefined;
};
